import { render } from "./PreClases.vue?vue&type=template&id=b82c23e0"
import script from "./PreClases.vue?vue&type=script&lang=js"
export * from "./PreClases.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ProductFactory\\analiaperez-landing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__